<!-- src/components/AppSideMenu.vue -->
<template>
  <nav class="side-menu">
    <h3 class="side-title">메인 메뉴</h3>

    <ul class="menu-list">
      <li @click="$emit('menu-click')">
        <router-link class="item" to="/dashboard" v-slot="{ isActive }">
          <img
            class="ico"
            :src="isActive ? icons.dashboardGreen : icons.dashboard"
            alt=""
          />
          대시보드
        </router-link>
      </li>

      <li @click="$emit('menu-click')">
        <router-link class="item" to="/booking" v-slot="{ isActive }">
          <img
            class="ico"
            :src="isActive ? icons.bookingGreen : icons.booking"
            alt=""
          />
          클래스 예약
        </router-link>
      </li>

      <li @click="$emit('menu-click')">
        <router-link class="item" to="/records" v-slot="{ isActive }">
          <img
            class="ico"
            :src="isActive ? icons.recordsGreen : icons.records"
            alt=""
          />
          내 기록
        </router-link>
      </li>

      <li @click="$emit('menu-click')">
        <router-link class="item" to="/profile" v-slot="{ isActive }">
          <img
            class="ico"
            :src="isActive ? icons.profileGreen : icons.profile"
            alt=""
          />
          개인정보 수정
        </router-link>
      </li>
    </ul>

    <div class="menu-sep"></div>

    <button class="item item--muted" type="button" @click="$emit('logout')">
      로그아웃
    </button>
  </nav>
</template>

<script>
import icDashboard from "@/assets/icons/ic-dashboard.png";
import icDashboardGreen from "@/assets/icons/ic-dashboard_green.png";
import icBooking from "@/assets/icons/ic-booking.png";
import icBookingGreen from "@/assets/icons/ic-booking_green.png";
import icRecords from "@/assets/icons/ic-records.png";
import icRecordsGreen from "@/assets/icons/ic-records_green.png";
import icProfile from "@/assets/icons/ic-profile.png";
import icProfileGreen from "@/assets/icons/ic-profile_green.png";

export default {
  name: "AppSideMenu",
  data() {
    return {
      icons: {
        dashboard: icDashboard,
        dashboardGreen: icDashboardGreen,
        booking: icBooking,
        bookingGreen: icBookingGreen,
        records: icRecords,
        recordsGreen: icRecordsGreen,
        profile: icProfile,
        profileGreen: icProfileGreen,
      },
    };
  },
};
</script>

<style scoped>
.side-menu {
  width: 280px;
  background: #151718;
  border-radius: 10px;
  color: #fff;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}
.side-title {
  margin: 4px 0 16px;
  font-size: 18px;
  font-weight: 400;
}
.menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
}

.item {
  width: 100%;
  height: 46px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 12px;
  background: transparent;
  border: 0;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  font-size: 16px;
  letter-spacing: -0.02em;
}
.item.router-link-active {
  background: #1b1d1e;
  border: 1px solid rgba(184, 184, 184, 0.2);
}

.item--muted {
  color: #8e8e8e;
  text-align: left;
}
.menu-sep {
  height: 12px;
}

.ico {
  width: 20px;
  height: 20px;
  display: block;
}
</style>
